export default [
    {
        name: 'base',
        data: {},
        items:
        [
            { name: 'smokeTexture', source: '/assets/smoke.png', type: 'texture' },
            { name: 'lightningTexture', source: '/assets/lightning.png', type: 'texture' },
            { name: 'particleMaskTexture', source: '/assets/particleMask.png', type: 'texture' },   
            { name: 'noise', source: '/assets/noise.jpg', type: 'texture' },   
            { name: 'veiny', source: '/assets/veiny.jpg', type: 'texture' },   
            { name: 'whiteMat', source: '/assets/whiteMat.png', type: 'texture' },   
            { name: 'greyNoise', source: '/assets/greyNoise.png', type: 'texture' }, 

            //progjects  
            { name: 'cantine', source: '/assets/cantine.jpg', type: 'texture' },   
            { name: 'daPortal', source: '/assets/daPortal.jpg', type: 'texture' },   
            { name: 'scrimba', source: '/assets/scrimba.jpg', type: 'texture' }, 
            
            //models
            { name: 'dungeonModel', source: '/assets/portal/bakingTestDungeon.glb'},
           
            //baked Textures
            { name: 'contact', source: '/assets/contactFinall80.jpg', type: 'texture' },   
            { name: 'leftWall', source: '/assets/leftWallFinall80.jpg', type: 'texture' },   
            { name: 'rightWall', source: '/assets/rightWallFinall80.jpg', type: 'texture' },   
            { name: 'portals', source: '/assets/portalsFinall80.jpg', type: 'texture' },      
            { name: 'floor', source: '/assets/finallFloor80.jpg', type: 'texture' },     
            { name: 'bridge', source: '/assets/testBridge.jpg', type: 'texture' } ,  
            { name: 'stairs', source: '/assets/stairsFinall80.jpg', type: 'texture' } ,  
            { name: 'details', source: '/assets/detailsFinall80.jpg', type: 'texture' },   
            { name: 'flag', source: '/assets/flag.jpg', type: 'texture' }   
        ]
    }
]